
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/home/canvas/public-html/ui/shared/outcomes/jst/findInstructions';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div class=\"wrapper\">\n  <h2 class=\"title\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("outcomes.find_instructions")
  },data:data},helper ? helper.call(depth0, "outcomes.find_instructions.instructions.find.title", "Finding Outcomes", options) : helperMissing.call(depth0, "t", "outcomes.find_instructions.instructions.find.title", "Finding Outcomes", options)))
    + "\n  </h2>\n  <div class=\"description\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'w0': ("<p>$1</p>"),
    'i18n_scope': ("outcomes.find_instructions")
  },data:data},helper ? helper.call(depth0, "outcomes.find_instructions.instructions.find.description", "*Outcomes created by your institution, or state can be accessed here. Just like in your course, the panel to the left will allow you to navigate between existing outcomes. Once you have found the outcome or outcome group you wish to use, click the import button below to add it to your course.*", options) : helperMissing.call(depth0, "t", "outcomes.find_instructions.instructions.find.description", "*Outcomes created by your institution, or state can be accessed here. Just like in your course, the panel to the left will allow you to navigate between existing outcomes. Once you have found the outcome or outcome group you wish to use, click the import button below to add it to your course.*", options)))
    + "\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  